import React from "react";
import * as Yup from "yup";
import { useParams, Link, useHistory } from "react-router-dom";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, Label } from "reactstrap";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from 'primereact/inputtextarea';
import EditorContainer from "../../components/EditorContainer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getSale, updateSale, createSale } from "../../api/sales";
import { createOrder } from "../../api/orders";
import { getTenant } from "../../api/tenants";
import { getCustomer, getCustomerVehicles } from "../../api/customers";
import { getProductsForTenant } from "../../api/products";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import SelectCustomer from "../../views/tenant/CustomerList";
import CreateCustomer from "../../views/tenant/CustomerEditor";
import CreateVehicle from "../../views/tenant/VehicleEditor";
import { canUserSave } from "../../auth/Can";
import roles from "../../auth/roles";

const schema = () =>
    Yup.object({
        customer_id: Yup.string()
            .required("Selezionare un cliente")
            .nullable(),
        attributes: Yup.object(),
        meta: Yup.object({
            product: Yup.object().required("Selezionare un prodotto"),
            quantity: Yup.number("Selezionare la quantitá")
                .required("Selezionare la quantitá")
                .nullable("Selezionare la quantitá")
                .typeError("Selezionare la quantitá"),
            /*  vehicles: Yup.array().when(
                 ["product", "quantity"],
                 (product, quantity, schema, vehicles) => {
                     return quantity > 0 &&
                         product &&
                         product.needsAuto.toString() === "true"
                         ? schema
                             .max(
                                 quantity,
                                 `${quantity} veicoli richiesti. Selezionati ${vehicles.value.length}`
                             )
                             .min(
                                 quantity,
                                 `${quantity} veicoli richiesti. Selezionati ${vehicles.value.length}`
                             )
                         : schema;
                 }
             ) */
        })
    });

const SaleEditor = ({ activeTenant, readOnly }) => {
    const { id } = useParams();
    const { domains, geo } = useAuth0();
    const [tenant, setTenant] = React.useState(activeTenant);
    const [customer, setCustomer] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [showSelCustomer, setShowSelCustomer] = React.useState(false);
    const [createCustomer, setCreateCustomer] = React.useState();
    const [createVehicle, setCreateVehicle] = React.useState();
    const [vehicles, setVehicles] = React.useState();
    const [products, setProducts] = React.useState();
    const [noSaveBtn, setNoSaveBtn] = React.useState(false);

    const { push } = useHistory();
    const { user } = useAuth0();

    const isAdmin = user.isInRole([roles.ADMIN], activeTenant)

    const onInit = async () => {
        const productsRes = await getProductsForTenant(activeTenant._id);
        const mapProds = productsRes.map(p => {
            const supplier = domains.suppliers.find(
                item => item.value === p.attributes.supplier
            ).label;
            const device = domains.devicesType.find(
                item => item.value === p.attributes.type
            ).label;
            return {
                _id: p._id,
                ...p.attributes,
                type_label: device,
                supplier_label: supplier,
                label: `${supplier} - ${device} - durata: ${p.attributes.duration} - ${p.attributes.description}`,
                value: p._id
            };
        });
        setProducts(mapProds);
    };

    const onCreate = async entity => {
        const result = await createSale({
            ...entity,
            tenant_id: activeTenant._id
        });
        return result;
    };

    const loadCustomer = async id => {
        try {
            setLoading(true);
            const custRes = await getCustomer(id);
            setCustomer(custRes);
        } finally {
            setLoading(false);
        }
    };

    const onLoad = async id => {
        const sale = await getSale(id);
        setNoSaveBtn(sale.status === "chiuso");
        const data = await Promise.all([
            getTenant(sale.tenant_id),
            loadCustomer(sale.customer_id),
            loadCustomerVehicles(sale.customer_id)
        ]);
        setTenant(data[0]);
        return sale;
    };

    const onUpdate = async entity => {
        const result = await updateSale(entity);
        return result;
    };

    const onCustomerChange = async (selCustomer, frmProps) => {
        const attributes = frmProps.values["attributes"] || {};
        frmProps.setFieldValue("customer_id", selCustomer._id);
        frmProps.setFieldValue("attributes", {
            ...attributes,
            created_for: `${selCustomer.name}`
        });
        const meta = frmProps.values.meta || {};
        frmProps.setFieldValue("meta", { ...meta, vehicles: [] });
        setCustomer(selCustomer);

        setShowSelCustomer(false);
        if (!selCustomer || !selCustomer._id) return;

        await loadCustomerVehicles(selCustomer._id);
    };

    const loadCustomerVehicles = async id => {
        setLoading(true);
        try {
            const cusVehicles = await getCustomerVehicles(id);
            setVehicles(cusVehicles);
        } finally {
            setLoading(false);
        }
    };

    const renderCustomer = () => {
        if (!customer) return null;
        return (
            <Card body color="default">
                <Row>
                    <Col sm="6" xs="12">
                        <strong className="mt-1 d-block">Ragione Sociale / Cognome - Nome</strong>
                        <Label className="mt-1 d-block h5">{customer.name}</Label>
                    </Col>
                    <Col sm="6" xs="12">
                        <strong className="mt-1 d-block">Indirizzo</strong>
                        <Label className="mt-1 d-block h5">{customer.address ? `${
                            customer.address.street
                            } - ${
                            customer.address.cap
                            } ${customer.address.city ? geo.getComuneLabel(customer.address.city) : ""} ${customer.address.province ? geo.getProvinceLabel(
                                customer.address.province
                            ) : ""} (${customer.address.province ? customer.address.province.toUpperCase() : ""})` : null}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">Telefono</strong>
                        <Label className="mt-1 d-block h5">{customer.attributes.phone}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">Email</strong>
                        <Label className="mt-1 d-block h5">{customer.email}</Label>
                    </Col>
                    <Col sm="6" xs="12" md="3">
                        <strong className="mt-1 d-block">C.F. / P.iva</strong>
                        <Label className="mt-1 d-block h5">{customer.taxcode}</Label>
                    </Col>
                </Row>
            </Card>
        );
    };

    const customerSelector = frmProps => {
        return (
            <Modal centered isOpen={showSelCustomer} backdrop={true} className="full-screen">
                <ModalHeader toggle={() => setShowSelCustomer(false)}>
                    Selezionare il Cliente:
                </ModalHeader>
                <ModalBody className="min-vh-100">
                    <SelectCustomer
                        activeTenant={activeTenant}
                        onSelect={e => {
                            onCustomerChange(e.value, frmProps);
                        }}
                        className="p-datatable-pointer"
                    />
                    <ModalFooter>
                        <div className="float-right">
                            <Button
                                className="my-2"
                                color="warning"
                                onClick={() => setShowSelCustomer(false)}
                            >
                                <FontAwesomeIcon icon="reply" /> Annulla
                        </Button>
                        </div>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        );
    };

    const customerCreator = frmProps => {
        return (
            <Modal centered isOpen={createCustomer ? true : false} backdrop={true} className="full-screen">
                <ModalHeader toggle={() => setCreateCustomer(false)}>
                    Nuovo Cliente:
                </ModalHeader>
                <ModalBody className="min-vh-100">
                    <CreateCustomer
                        initCustomer={customer}
                        activeTenant={activeTenant}
                        onCreated={cust => {
                            onCustomerChange(cust, frmProps);
                        }}
                    />
                    <ModalFooter>
                        <div className="float-right">
                            <Button
                                className="my-2"
                                color="warning"
                                onClick={() => setCreateCustomer(false)}
                            >
                                <FontAwesomeIcon icon="reply" /> Annulla
                        </Button>
                        </div>
                    </ModalFooter>
                </ModalBody>
            </Modal>
        );
    };

    const getSelectedVehicles = (selectedVehicles, customerVehicles) => {
        const ids = (selectedVehicles || []).map(el => el._id);
        return (customerVehicles || []).filter(el => ids.includes(el._id))

    }

    const vehicleSelector = frmProps => {
        const meta = frmProps.values["meta"];
        const showVehicles =
            meta && meta.product && meta.product.needsAuto
                ? meta.product.needsAuto.toString() === "true"
                : false;
        if (!showVehicles) return null;
        const metaErrors = frmProps.errors.meta || {};
        return (
            <Col xs="12">
                {vehicleCreator(frmProps)}
                <div className="divider my-3" />
                <div className="mt-2 mb-1"><strong>Veicoli del Cliente associati alla Vendita:</strong></div>
                {metaErrors.vehicles ? (<div className="invalid-feedback">{metaErrors.vehicles}</div>) : null}
                <DataTable
                    loading={loading}
                    autoLayout={false}
                    value={vehicles || []}
                    className="p-datatable-hoverable-rows p-datatable-customers p-datatable-pointer"
                    emptyMessage={() => (<div className="text-center">Nessun Veicolo in tabella</div>)}
                    onSelectionChange={e => {
                        frmProps.setFieldValue("meta", { ...meta, vehicles: e.value });
                    }}
                    paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                    currentPageReportTemplate="Visualizzati {first} di {last} Veicoli su un totale di {totalRecords}"
                    header={frmProps.values["status"] !== "chiuso" && (
                        <div className="p-clearfix" style={{ lineHeight: "1.87em" }}>
                            <div style={{ float: "left" }}>
                                <Button
                                    color="primary"
                                    onClick={() => setCreateVehicle("manual")}
                                    className="mr-2"
                                >
                                    <FontAwesomeIcon icon="car" className="mr-1" /> Aggiungi veicolo
                                </Button>
                                <Button
                                    color="primary"
                                    onClick={() => setCreateVehicle("fromPlate")}
                                >
                                    <FontAwesomeIcon icon="taxi" className="mr-1" /> Aggiungi veicolo da targa
                                </Button>
                            </div>
                        </div>
                    )}
                    selectionMode="multiline"
                    metaKeySelection={false}
                    selection={getSelectedVehicles(meta.vehicles, vehicles)}
                >
                    <Column
                        selectionMode="multiple"
                        style={{ width: '3em' }}
                    />
                    <Column
                        field="plate"
                        header="Targa"
                        sortable
                        filter
                        filterMatchMode="contains"
                    />
                    <Column
                        field="attributes.preparation"
                        style={{ wordWrap: "break-word" }}
                        header="Allestimento"
                        sortable
                        filter
                        filterMatchMode="contains"
                    />
                    <Column
                        field="km"
                        style={{ wordWrap: "break-word" }}
                        header="Km"
                        sortable
                        filter
                        filterMatchMode="contains"
                    />
                </DataTable>
            </Col>
        );
    };

    const vehicleCreator = frmProps => {
        return (
            <Modal centered isOpen={createVehicle ? true : false} backdrop={true} className="full-screen">
                <ModalHeader toggle={() => setCreateVehicle(undefined)}>
                    Crea veicolo
                </ModalHeader>
                <ModalBody className="min-vh-100">
                    <CreateVehicle
                        initCustomer={customer}
                        activeTenant={activeTenant}
                        fromPlate={createVehicle === "fromPlate"}
                        onCreated={async vehic => {
                            await loadCustomerVehicles(customer._id);
                            const meta = frmProps.values["meta"];
                            const selectedVehicles = meta.vehicles || [];
                            const newSelested = selectedVehicles.concat(vehic);
                            frmProps.setFieldValue("meta", {
                                ...meta,
                                vehicles: newSelested
                            });
                            setCreateVehicle(undefined);
                        }}
                    />
                </ModalBody>
            </Modal>
        );
    };

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Chiusura Vendita
        </ModalHeader>
            <ModalBody>
                <p>Confermi di voler chiudere la Vendita{`${!isAdmin ? " e creare l'Ordine" : ""}`}?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="primary" className="ml-auto" onClick={() => onCloseSell(openModal)}>Chiudi Vendita</Button>
            </ModalFooter>
        </Modal>
    );

    const onCloseSell = async frmProps => {
        const entity = frmProps.values;
        const value = await updateSale(entity, "chiuso");
        let proceed;
        if (isAdmin) {
            proceed = confirm(`Vuoi creare anche l'ordine?`);
        }
        if (proceed || !isAdmin) {
            const result = await createOrder({
                order_ref: user.name,
                status: "inserito",
                quantity: entity.meta.quantity,
                tenant_id: tenant._id,
                user_id: entity.customer_id,
                model: entity.meta.product.type,
                created_for: entity.attributes.created_for,
                creator_email: user.email,
                notes: entity.meta.notes
            });
        }
        toggle();
        push(`/tenant/sales`);
    }

    const [openSell, setOpenSell] = React.useState(false);
    const toggleSell = () => setOpenSell(!openSell);

    const modalOpenSell = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openSell ? true : false} backdrop={true}>
            <ModalHeader toggle={toggleSell}>
                Riapertura Vendita
        </ModalHeader>
            <ModalBody>
                <p>Confermi di voler riaprire la Vendita?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggleSell}>Annulla</Button>{' '}
                <Button color="primary" className="ml-auto" onClick={() => onOpenSell(openSell)}>Riapri Vendita</Button>
            </ModalFooter>
        </Modal>
    );

    const onOpenSell = async frmProps => {
        const entity = frmProps.values;
        const value = await updateSale(entity, "inserito");
        toggleSell();
        push(`/tenant/sales`);
    }

    return (
        <EditorContainer
            key={id ? `${id}-sale` : "new-sale"}
            canSave={canUserSave([roles.VENDITORE, roles.DEALER, roles.ADMIN])}
            noSaveBtn={noSaveBtn}
            schema={schema}
            onCreate={onCreate}
            onUpdate={onUpdate}
            onInit={onInit}
            onLoad={onLoad}
            optionalNav={{ link: `/tenant/sales`, text: "Vendite" }}
            redirRoot={`/tenant/sales`}
            title={el =>
                `${id ? el.attributes.created_for : "NUOVA VENDITA"}`
            }
            children={frmProps => {
                const meta = frmProps.values["meta"] || {
                    quantity: "",
                    product: undefined,
                    vehicles: undefined
                };

                const metaErrors = frmProps.errors.meta || {};
                const attributes = frmProps.values["attributes"] || {};
                return (
                    <Row>
                        <Col sm="12" xs="12">
                            {!id && (
                                <div>
                                    <strong className="mt-2">Cliente:</strong>
                                    <div>
                                        <Button
                                            color="primary"
                                            onClick={() => setShowSelCustomer(true)}
                                            title="Seleziona Cliente"
                                            className="mr-1 mb-2"
                                        >
                                            <FontAwesomeIcon icon="hand-pointer" className="mr-1" />Elenco Clienti
                                    </Button>
                                        <Button
                                            color="primary"
                                            onClick={() => setCreateCustomer(true)}
                                            title="Aggiungi Cliente"
                                            className="mr-1 mb-2"
                                        >
                                            <FontAwesomeIcon icon="user-shield" className="mr-1" />Nuovo Cliente
                                    </Button>
                                    </div>
                                </div>
                            )}
                            {id && frmProps.values["status"] === "inserito" && (
                                <div>
                                    <Button
                                        color="primary"
                                        onClick={() => setOpenModal(frmProps)}
                                        title="Chiudi la Vendita"
                                        className="mr-2 mb-2"
                                    >
                                        <FontAwesomeIcon icon="store-slash" className="mr-1" />Chiudi Vendita
                                    </Button>
                                </div>
                            )}
                            {id && isAdmin && frmProps.values["status"] === "chiuso" && (
                                <div>
                                    <Button
                                        color="success"
                                        onClick={() => setOpenSell(frmProps)}
                                        title="Apri la Vendita"
                                        className="mr-2 mb-2"
                                    >
                                        <FontAwesomeIcon icon="store" className="mr-1" />Riapri Vendita
                                </Button>
                                </div>
                            )}
                            {renderCustomer()}
                            {customerSelector(frmProps)}
                            {customerCreator(frmProps)}
                            {modalSection()}
                            {modalOpenSell()}
                            {frmProps.errors.customer_id ? (<div className="invalid-feedback">{frmProps.errors.customer_id}</div>) : null}
                        </Col>
                        <Col sm="9" xs="12" className="mt-2">
                            <strong className="mt-2">Prodotto:</strong>
                            <Dropdown
                                disabled={id && frmProps.values["status"] === "chiuso" ? true : false}
                                filter
                                filterBy="label"
                                id="product"
                                className={metaErrors.product ? "p-error" : ""}
                                value={meta.product ? meta.product._id : ""}
                                showClear={true}
                                style={{ width: "100%" }}
                                options={products}
                                onChange={e => {
                                    const prod = e.value;
                                    const selected = products.find(el => el._id === prod);
                                    const needCars = selected.needsAuto.toString() === "true";
                                    frmProps.setFieldValue("attributes", {
                                        ...attributes,
                                        type: selected.type,
                                        model: selected.model,
                                        supplier: selected.supplier
                                    });
                                    frmProps.setFieldValue("meta", {
                                        ...meta,
                                        product: selected,
                                        vehicles: selected && !needCars ? [] : meta.vehicles
                                    });
                                }}
                            />
                            {metaErrors.product ? (<div className="invalid-feedback">{metaErrors.product}</div>) : null}
                        </Col>
                        <Col sm="3" xs="12" className="mt-2">
                            <strong className="mt-2">Quantitá</strong>
                            <InputText
                                disabled={id && frmProps.values["status"] === "chiuso" ? true : false}
                                className={metaErrors.quantity ? "p-error" : ""}
                                value={meta.quantity || ""}
                                style={{ width: "100%" }}
                                keyfilter="pint"
                                onChange={e => {
                                    frmProps.setFieldValue("attributes", {
                                        ...attributes,
                                        quantity: e.target.value
                                    });
                                    frmProps.setFieldValue("meta", {
                                        ...meta,
                                        quantity: e.target.value
                                    });
                                }}
                            />
                            {metaErrors.quantity ? (<div className="invalid-feedback">{metaErrors.quantity}</div>) : null}
                        </Col>
                        <Col sm="12" xs="12">
                            <strong className="mt-2">Note</strong>
                            <InputTextarea
                                disabled={id && frmProps.values["status"] === "chiuso" ? true : false}
                                className={metaErrors.notes ? "p-error" : ""}
                                rows={2}
                                value={meta.notes || ""}
                                style={{ width: "100%" }}
                                onChange={e => {
                                    frmProps.setFieldValue("attributes", {
                                        ...attributes,
                                        notes: e.target.value
                                    });
                                    frmProps.setFieldValue("meta", {
                                        ...meta,
                                        notes: e.target.value
                                    });
                                }}
                            />
                            {metaErrors.notes ? (<div className="invalid-feedback">{metaErrors.notes}</div>) : null}
                        </Col>
                        {vehicleSelector(frmProps)}
                    </Row>
                );
            }}
            renderDealer={() =>
                tenant ? (
                    <React.Fragment>
                        <Card body className="rounded bg-secondary mb-2">
                            <Row>
                                <Col sm="4" xs="12">
                                    <strong>Dealer: </strong>
                                    <Label className="h5">{tenant.name}</Label>
                                </Col>
                                <Col sm="4" xs="12" md="3">
                                    <strong>Telefono: </strong>
                                    <Label className="h5">{tenant.phone}</Label>
                                </Col>
                                <Col sm="4" xs="12" md="3">
                                    <strong>Email: </strong>
                                    <Label className="h5">{tenant.email}</Label>
                                </Col>
                            </Row>
                        </Card>
                    </React.Fragment>
                ) : (
                        <Spinner style={{ width: "3rem", height: "3rem" }} type="grow" />
                    )
            }
        />
    );
};
export default SaleEditor;
